import { useRecoilValue } from 'recoil'

import Step from './Step'

import { workflowState } from 'Pages/WorkflowStatistics/recoil/state/workflow'

const StepsBlock = () => {
  const { steps } = useRecoilValue(workflowState)

  const filteredSteps = steps.filter(
    (step) => step.message && step.message.IdMessage > 0
  )

  return (
    <>
      {filteredSteps.map(
        (step, index) =>
          step.message.IdMessage !== 0 && (
            <Step
              key={index}
              index={index}
              message={step.message}
              isLast={index === filteredSteps.length - 1}
              isFirst={index === 0}
            />
          )
      )}
    </>
  )
}

export default StepsBlock
